export class PermissionSet {
  // Model Builder
  public accessModelBuilder: boolean;

  // Events
  public eventsView: boolean;
  public eventsCreateEdit: boolean;
  public eventsReactivate: boolean;

  // RBI
  public rbiReadOnly: boolean;
  public rbiSaveRiskRun: boolean;
  public rbiRunRisk: boolean;
  public rbiRunMassCriticality: boolean;

  // Mitigations
  public activateMitigation: boolean;
  public includeMitigation: boolean;
  public readMitigation: boolean;

  // Inspection Reports
  public inspectionReportsShow: boolean;
  public inspectionReportsAdd: boolean;
  public inspectionReportsEdit: boolean;
  public inspectionReportsReadOnly: boolean;

  // Thickness Locations Management
  public readThicknessLocations: boolean;
  public editThicknessLocations: boolean;
  public addThicknessLocations: boolean;

  // Thickness Reports Mangement
  public thicknessReportsShow: boolean;
  public thicknessReportsAdd: boolean;
  public thicknessReportsEdit: boolean;
  public thicknessReportsReadOnly: boolean;

  // Hierarchy Items
  public readHierarchy: boolean;
  public editHierarchy: boolean;
  public addHierarchy: boolean;

  // Reports
  public accessReports: boolean;

  // DataUpload
  public readDataUpload: boolean;
  public editDataUpload: boolean;
  public addDataUpload: boolean;

  // Admin
  public accessAdmin: boolean;
  public licenceManagement: boolean;

  // Install models
  public downloadModel: boolean;
  public uploadModel: boolean;

  // RCM
  public rcmAccess: boolean;
  public rcmRead: boolean;
  public rcmEdit: boolean;
  public rcmCreate: boolean;

  // Maintenance Optimization
  public optimizationRead: boolean;
  public optimizationSave: boolean;
  public optimizationCalculate: boolean;

  public isSecurity: boolean;
}
